export default function toLocaleUpperCaseFixed(string) {
  return [...string]
    .map(letter => letter === 'ß' ? 'ẞ' : letter.toLocaleUpperCase())
    .join('');
}
